// In components/common/ThemeToggle/index.tsx
import { useTheme } from '../../../contexts/ThemeContext';
import { Icon } from '@iconify/react';

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="
        p-2 rounded-md
        bg-surface-secondary hover:bg-surface-tertiary
        text-text-primary
        focus-visible
        transition-all duration-200 ease-in-out
      "
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <Icon
        icon={isDark ? 'ph:sun-thin' : 'ph:moon-thin'}
        className="w-5 h-5"
      />
    </button>
  );
};

export default ThemeToggle;